export default __webpack_public_path__ + "static/media/NO_Solid_Colors.eb2aedb1.jpg";